import _ from 'lodash';
/*
* Root selector
 */
export const getAuthentication = (state) => {
  return state.authentication;
};


/*
* Credentials selectors
 */
export const getCredentials = (state) => {
  const { credentials } = getAuthentication(state);
  return credentials;
};


export const getAuthenticated = (state) => {
  const { isAuthenticated } = getAuthentication(state);
  return isAuthenticated;
};


export const getUrlEncodedCredentials = (state) => {
  const credentials = getCredentials(state);
  const queryParams = _.entries(credentials).map(([key, value]) => { return `${key}=${value}`; }).join('&');
  return `${queryParams}`;
};


/*
* User selectors
 */
export const getUser = (state) => {
  const { user } = getAuthentication(state);
  return user;
};


export const getUserEmail = (state) => {
  const { email } = getUser(state);
  return email;
};


export const getUserDefaultDistrictId = (state) => {
  const { default_district_id: defaultDistrictId } = getUser(state);
  return defaultDistrictId;
};


export const getUserDefaultDepartmentId = (state) => {
  const { default_department_id: defaultDepartmentId } = getUser(state);
  return defaultDepartmentId;
};


export const getUserTimeZone = (state) => {
  const { timezone: timeZone } = getUser(state);
  return timeZone;
};


export const getUserFeatures = (state) => {
  const { hsiui_features: features } = getUser(state);
  return features;
};

export const getPerDiemFeature = (state) => {
  const { per_diem: perDiem } = getUserFeatures(state);
  return perDiem;
};

export const getPerDiemRequestFeature = (state) => {
  const { per_diem_request: perDiemRequest } = getUserFeatures(state);
  return perDiemRequest;
};

export const getCorpAdminFeature = (state) => {
  const { corp_admin: corpAdmin } = getUserFeatures(state);
  return corpAdmin;
};

export const getViewerFeature = (state) => {
  const { viewer } = getUserFeatures(state);
  return viewer;
};


/*
* Login selectors
 */
export const getLoginLoadingStatus = (state) => {
  const { isLoading } = getAuthentication(state);
  return isLoading;
};


export const getLoginErrorMessage = (state) => {
  const { errorMessage } = getAuthentication(state);

  if (errorMessage === null) {
    return '';
  }

  return errorMessage;
};


export const getLoginErrorStatus = (state) => {
  const { errorMessage } = getAuthentication(state);
  const errorStatus = errorMessage !== null;
  return errorStatus;
};
